var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details-container"},[_c('div',{staticClass:"back-link"},[_c('a',{on:{"click":_vm.goBack}},[_c('b-icon-arrow-left'),_vm._v(" Back to Browse")],1)]),_c('game-details',{attrs:{"id":_vm.itemId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }